import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import Icon from "../../assets/icon.png";
import IosShareIcon from "@mui/icons-material/IosShare";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PwaModal({ showPwa, setShowPwa }) {
  const theme = useTheme();
  const textColor = theme.palette.text.primary;
  const handleClose = () => {
    setShowPwa(false);
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={showPwa}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <Box
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            mb: 6,
            p: "24px",
            direction: "rtl",
          }}
        >
          <Stack
            spacing={1}
            justifyContent={"center"}
            alignItems={"center"}
            display={"flex"}
          >
            <Box
              sx={{
                background: theme.palette.primary.main,
                borderRadius: "16px",
                paddingRight: "12px",
                width: "128px",
                marginBottom: "24px !important",
              }}
            >
              <img src={Icon} width={"128px"} />
            </Box>
            <Typography
              variant="h6"
              component="h2"
              textAlign={"center"}
              sx={{ fontWeight: "600" }}
            >
              نسخه وب اپلیکیشن شیپیتو را به صفحه اصلی خود اضافه
              کنید
            </Typography>
            <Typography
              textAlign={"center"}
              sx={{ mt: 2, mb: 2, color: "gray", fontSize: "16px" }}
              component="h2"
            >
              با این کار، می‌توانید برای همیشه و بدون نیاز به بروزرسانی از خدمات
              ما استفاده کنید
            </Typography>
            <Stack
              spacing={3}
              justifyContent={"space-between"}
              alignItems={"center"}
              display={"center"}
              flexDirection={"row"}
              width={"100%"}
              textAlign={"left"}
              whiteSpace={"nowrap"}
            >
              <IosShareIcon
                sx={{ fontSize: "30px", color: "text.primary", pt: "14px" }}
              />
              <Typography sx={{ fontSize: "18px", color: "text.primary" }}>
                در نوار پایین کلیک کنید
                <span
                  style={{
                    color: textColor,
                    fontSize: "15px",
                    fontWeight: "600",
                    marginLeft: "5px",
                    marginRight: "5px",
                  }}
                >
                  Share
                </span>
                روی دکمه
              </Typography>
            </Stack>
            <Stack
              spacing={3}
              justifyContent={"space-between"}
              alignItems={"center"}
              display={"center"}
              flexDirection={"row"}
              width={"100%"}
              textAlign={"left"}
              whiteSpace={"nowrap"}
            >
              <AddBoxOutlinedIcon
                sx={{ fontSize: "30px", color: "text.primary", pt: "18px" }}
              />
              <Typography sx={{ fontSize: "18px", color: "text.primary" }}>
                کلیک کنید
                <span
                  style={{
                    color: textColor,
                    fontSize: "14px",
                    fontWeight: "600",
                    marginLeft: "5px",
                    marginRight: "5px",
                    flexWrap: "nowrap",
                  }}
                >
                  Add to Home Screen
                </span>
                روی دکمه
              </Typography>
            </Stack>
            <Stack
              spacing={3}
              justifyContent={"space-between"}
              alignItems={"center"}
              display={"center"}
              flexDirection={"row"}
              width={"100%"}
              textAlign={"left"}
              whiteSpace={"nowrap"}
            >
              <span
                style={{
                  fontSize: "18px",
                  paddingTop: "24px",
                  color: textColor,
                  fontWeight: "600",
                }}
              >
                Add
              </span>
              <Typography sx={{ fontSize: "18px", mt: 2, color: "text.primary" }}>
                کلیک کنید
                <span
                  style={{
                    color: textColor,
                    fontSize: "14px",
                    fontWeight: "600",
                    marginLeft: "5px",
                    marginRight: "5px",
                  }}
                >
                  Add
                </span>
                در قسمت بالا روی
              </Typography>
            </Stack>
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: "20px !important", color: "primary.contrastText", width: "100%" }}
              onClick={handleClose}
              size="large"
            >
              متوجه شدم!
            </Button>
          </Stack>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
